import script from "./CreateProjectStep2.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateProjectStep2.vue?vue&type=script&setup=true&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./CreateProjectStep2.vue?vue&type=style&index=1&id=35b3320e&lang=scss&scoped=true"

import exportComponent from "/home/deployer/deploypad/silogues/releases/20261022152544/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35b3320e"]])

export default __exports__